import {
    ApiHandlerDiscreteParameter,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { post } from "@insite/client-framework/Services/ApiService";
import { SubscribeToListApiParameter } from "@insite/client-framework/Services/EmailService";
import { chain, SendDataToApi } from "@insite/client-framework/Store/CommonHandlers/Subscribe";

type SubmitSubscribeParameter = {
    email: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitSubscribeParameter, SubscribeToListApiParameter>;

const emailsUrl = "/api/v1/email";

export function submitSubscribeExtendedForm(parameter: SubscribeToListApiParameter) {
    return post<SubscribeToListApiParameter, void>(`${emailsUrl}/SubscribeToListExtended`, parameter);
}

export const SendDataToCustomApi: HandlerType = async props => {
    await submitSubscribeExtendedForm(props.apiParameter);
};

replaceInChain(chain, SendDataToApi, SendDataToCustomApi);